import type { SVGProps } from "react";
export interface HatIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function HatIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: HatIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M18.611 13.45a1.125 1.125 0 0 1 .778 2.11c-1.706.63-4.04 1.065-7.388 1.065-2.93 0-5.084-.334-6.72-.84l-.67-.225-.106-.045a1.126 1.126 0 0 1 .775-2.1l.11.034.553.188c1.371.423 3.292.738 6.058.738 3.16 0 5.217-.412 6.61-.926Zm0-3.502a1.126 1.126 0 0 1 .778 2.113c-1.706.629-4.04 1.065-7.388 1.065-2.93 0-5.084-.335-6.72-.84l-.67-.225-.106-.046a1.126 1.126 0 0 1 .775-2.1l.11.033.553.188c1.371.423 3.292.74 6.058.74 3.16 0 5.217-.413 6.61-.928"
      />
      <path
        fill={color}
        d="M17.863 7.256a2.375 2.375 0 0 0-2.351-2.131A4.82 4.82 0 0 1 12 6.625a4.83 4.83 0 0 1-3.515-1.5A2.375 2.375 0 0 0 6.125 7.5v7.357c0 .5-.329.94-.807 1.08-.867.255-1.49.538-1.868.803a1.4 1.4 0 0 0-.294.259c.04.051.12.136.281.25.366.26.969.54 1.815.795 1.678.503 4.065.831 6.749.831s5.068-.328 6.747-.831c.846-.254 1.45-.535 1.816-.794a1.3 1.3 0 0 0 .278-.251 1.4 1.4 0 0 0-.293-.26c-.378-.264-1-.547-1.866-.802a1.13 1.13 0 0 1-.808-1.08V7.5zm2.262 6.788c.656.24 1.241.523 1.713.853.627.438 1.287 1.132 1.287 2.103 0 .96-.644 1.648-1.26 2.085-.646.458-1.507.824-2.47 1.113-1.94.582-4.555.927-7.394.927s-5.454-.345-7.395-.927c-.963-.289-1.825-.655-2.471-1.113-.578-.41-1.18-1.04-1.253-1.909l-.007-.175.007-.18c.075-.879.692-1.513 1.28-1.924.471-.33 1.057-.612 1.713-.853V7.5A4.625 4.625 0 0 1 8.5 2.875H9l.14.009c.318.04.606.215.79.483q-.002-.003 0-.003l.012.02c.016.02.045.057.087.103.085.096.217.23.395.364a2.58 2.58 0 0 0 1.577.524c.7 0 1.22-.258 1.574-.524a2.7 2.7 0 0 0 .484-.468l.011-.016-.003.003-.001.003-.002.002v.001c.21-.313.56-.501.937-.501h.499A4.624 4.624 0 0 1 20.125 7.5z"
      />
    </svg>
  );
}
